import DesktopAsideMenu from './DesktopAsideMenu';

export default DesktopAsideMenu;
